import cs from 'classnames';

import { highlightText } from 'lib/helpers/utility';

import Icon from '../Icon/Icon';

const Info = ({
  info,
  infoHighlights = [],
  infoIcon = 'myscribeai-filled',
  infoIconSize = 24,
  error
}) => {
  if (!info) return null;

  return (
    <div
      className={cs(
        'z-20 flex items-start gap-x-1 border-x-0 border-b-0 border-t border-solid px-4 py-2 text-sm font-400 leading-[22px]',
        error
          ? 'border-danger-200 bg-danger-50 text-danger-600'
          : 'border-primary-200 bg-white-to-primary text-primary-600'
      )}>
      {infoIcon && (
        <Icon
          size={infoIconSize}
          icon={infoIcon}
          color={error ? 'danger' : 'primary'}
          className={cs(infoIcon === 'myscribeai-filled' && 'animate-pulse')}
        />
      )}
      <div>{highlightText(info, infoHighlights)}</div>
    </div>
  );
};

export default Info;
